import { render } from "./RatingModal.vue?vue&type=template&id=b2a9a9a8"
import script from "./RatingModal.vue?vue&type=script&lang=js"
export * from "./RatingModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__